import Vue from 'vue'
import VueI18n from 'vue-i18n'
import AdventureManager from "../manager/AdventureManager";

Vue.use(VueI18n)

// 以下为语言包单独设置的场景，单独设置时语言包需单独引入
const messages = {
    'en': require('./i18n/en.json'), // 英文语言包
    'zh': require('./i18n/zh.json'), // 中文语言包
    'ar': require('./i18n/ar.json'), // 阿拉伯语言包
    'vi': require('./i18n/vi.json'), // 越南语言包
    'he': require('./i18n/he.json'), // 希伯来语言包
}

let lan = AdventureManager.getLanguage();

export default new VueI18n({
    locale: lan, // set locale 默认显示英文
    fallbackLocale: 'en',
    messages,
    silentTranslationWarn: false,
})


// WEBPACK FOOTER //
// ./src/utils/i18n.js